"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var diacritics_1 = require("./diacritics");
/**Realiza una busqueda de texto y devuelve las partes en donde encaja la cadena, el arreglo resultante tendrá por lo menos un elemento si el texto SI encaja */
function search(pattern, text) {
    if (!pattern)
        return true;
    if (!text)
        return false;
    pattern = diacritics_1.removeDiacritics(pattern.toLowerCase());
    text = diacritics_1.removeDiacritics(text.toLowerCase());
    var splitter = /(?:\s|\n|\r)/g;
    var tw = text.split(splitter);
    var pw = pattern.split(splitter);
    if (pw.length == 0)
        return true;
    if (pw.length == 1)
        return text.indexOf(pattern) != -1;
    var cadaPalabra = pw.map(function (x) { return text.indexOf(x) != -1; }).reduce(function (a, b) { return a && b; }, true);
    return cadaPalabra;
}
exports.search = search;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NlYXJjaC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDJDQUFnRDtBQU9oRCxnS0FBZ0s7QUFDaEssZ0JBQXVCLE9BQWtDLEVBQUUsSUFBK0I7SUFDdEYsSUFBSSxDQUFDLE9BQU87UUFBRSxPQUFPLElBQUksQ0FBQztJQUMxQixJQUFJLENBQUMsSUFBSTtRQUFFLE9BQU8sS0FBSyxDQUFDO0lBRXhCLE9BQU8sR0FBRyw2QkFBZ0IsQ0FBQyxPQUFPLENBQUMsV0FBVyxFQUFFLENBQUMsQ0FBQztJQUNsRCxJQUFJLEdBQUcsNkJBQWdCLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUM7SUFFNUMsSUFBTSxRQUFRLEdBQUcsZUFBZSxDQUFBO0lBQ2hDLElBQU0sRUFBRSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDaEMsSUFBTSxFQUFFLEdBQUcsT0FBTyxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUVuQyxJQUFJLEVBQUUsQ0FBQyxNQUFNLElBQUksQ0FBQztRQUFFLE9BQU8sSUFBSSxDQUFDO0lBQ2hDLElBQUksRUFBRSxDQUFDLE1BQU0sSUFBSSxDQUFDO1FBQUUsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0lBRXZELElBQU0sV0FBVyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUMsVUFBQSxDQUFDLElBQUksT0FBQSxJQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUF0QixDQUFzQixDQUFDLENBQUMsTUFBTSxDQUFDLFVBQUMsQ0FBQyxFQUFFLENBQUMsSUFBSyxPQUFBLENBQUMsSUFBSSxDQUFDLEVBQU4sQ0FBTSxFQUFFLElBQUksQ0FBQyxDQUFDO0lBRXZGLE9BQU8sV0FBVyxDQUFDO0FBQ3ZCLENBQUM7QUFqQkQsd0JBaUJDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/keautils/dist/search.js
// module id = 2278
// module chunks = 0